<template>
    <el-card shadow="hover">
        <label slot="header">富文本</label>
        <el-divider content-position="left">v-model="editorVal"</el-divider>
        <j-editor style="width: 800px;" v-model="editorVal" />
        <el-divider content-position="left">:height="200" </el-divider>
        <j-editor style="width: 800px;" v-model="editorVal" :height="200" />
    </el-card>
</template>

<script>
    import JEditor from "./JEditor";
    export default {
        components: {
            JEditor
        },
        data() {
            return {
                editorVal: ''
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
